const measurements = [
    "bundle",
    "item",
    "grams",
    "kilograms",
    "centiliter",
    "litre"
]

export default measurements
